// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
/* eslint-disable @typescript-eslint/no-explicit-any */
import { fetchLastDashboardsPoolResourceExportJob } from 'apis/dashboards/dashboardApi';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { DashboardsPoolResourcesExportJobStatus } from 'util/Enums';
import { DashboardsPoolResourcesExportJob } from 'util/Types';

const EXPORT_POLL_DASHBOARD_CHECK_INTERVAL = 5000; // 5 seconds

export const useCheckPoolDashboardExporting = () => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState<
    | boolean
    | {
        jobId: number;
      }
  >(true);
  const [exportedJobData, setExportedJobData] =
    useState<DashboardsPoolResourcesExportJob>();
  const [isFailed, setIsFailed] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const clearTimeoutRef = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const checkExportProcess = async (checkCount: number) => {
    if (!isProcessing) {
      return;
    }

    setIsFailed(false);
    setExportedJobData(undefined);

    await fetchLastDashboardsPoolResourceExportJob({
      successCallback: (data) => {
        if (
          data?.status === DashboardsPoolResourcesExportJobStatus.Processing
        ) {
          timeoutRef.current = setTimeout(
            () => checkExportProcess(checkCount + 1),
            EXPORT_POLL_DASHBOARD_CHECK_INTERVAL
          );

          return;
        }

        clearTimeoutRef();

        if (data?.status === DashboardsPoolResourcesExportJobStatus.Failed) {
          setIsFailed(true);

          if (
            (typeof isProcessing === 'object' && isProcessing.jobId != null) ||
            checkCount > 0
          ) {
            toast.error(
              t('pool_dashboard.resources_table.export.export_failed')
            );
          }
        }

        if (data?.downloadUrl) {
          setExportedJobData(data);

          if (
            (typeof isProcessing === 'object' && isProcessing.jobId != null) ||
            checkCount > 0
          ) {
            toast.success(
              t('pool_dashboard.resources_table.export.export_completed')
            );
          }
        }

        setIsProcessing(false);
      },
      failedCallback: () => {
        setIsProcessing(false);
        setExportedJobData(undefined);
        setIsFailed(true);
      },
    });
  };

  useEffect(() => {
    checkExportProcess(0);

    return () => {
      clearTimeoutRef();
    };
  }, [isProcessing]);

  return {
    isProcessing,
    exportedJobData,
    failedMessage: isFailed
      ? t('pool_dashboard.resources_table.export.export_failed')
      : undefined,
    setIsProcessing,
  };
};
